module.exports = __webpack_public_path__ + "static/media/logo.9543fd1f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 24
// module chunks = 0